export default __webpack_public_path__ + "static/media/Hooman Hatefi CV.4646b8a3.pdf";